























































































































// import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { AddressFormObjType } from './types';

const cssPrefix = 'address-verification';
@Component({
  components: {
    ...UUIFComponents,
  },
})
export default class AddressVerificationComponent  extends SwExtendedVue {
  cssPrefix = cssPrefix;
  suggestedAddressVariable: boolean = false;
  @Prop()
  addressFormSuggested: AddressFormObjType;

  @Prop()
  addressFormApplied: AddressFormObjType;

  @Prop({ default: false })
  suggestedAddress: boolean;

  @Prop()
  addressVerificationMessage: string;

  confirmSuggested() {
    this.$emit('useSuggestedAddress');
  }

  confirmAppliedAddress() {
    this.$emit('useAppliedAddress');
  }

  onBack() {
    this.$emit('onBack');
  }
  created() {
    this.suggestedAddressVariable = this.suggestedAddress;
  }
}
